export const accessLevel = (role) =>
  role === "Manager" ? "owner" : role === "Management User" ? "management" : role === "Viewer" ? "viewer" : "operator";

export const isOwner = (r) => accessLevel(r) === "owner";
export const isManagement = (r) => accessLevel(r) === "management";
export const isViewer = (r) => accessLevel(r) === "viewer";
export const isOperator = (r) => accessLevel(r) === "operator";
export const isAdmin = (r) => ["owner", "management"].includes(accessLevel(r)); // create/edit data + see financials
export const canManageUsers = (r) => isOwner(r);
export const canSeeFinancials = (r) => !isOperator(r);

export const canWriteEntity = (r, e) => {
  const l = accessLevel(r);
  if (l === "viewer") return false;
  if (l === "owner" || l === "management") return true;
  return e === "production"; // operator
};

export const canDeleteEntity = (r, e) => {
  const l = accessLevel(r);
  if (l === "owner") return true;
  if (l === "management") return e !== "jobs";
  return false;
};

// nav + route access by key
export const canAccessEntity = (r, key) => {
  const l = accessLevel(r);
  if (l === "owner") return true;
  if (l === "management") return !["users", "audit"].includes(key);
  if (l === "viewer") return ["dashboard", "reports"].includes(key);
  return key === "production"; // operator: only log-production route
};

export const homePath = (r) => (accessLevel(r) === "viewer" ? "/reports" : "/");
